import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import { Button, Typography } from '@tkww/the-bash-frontend';

import TextField from 'components/TextField';
import Select from 'components/Select';
import { selectIsMobile } from 'state/modules/viewport';
import { FORM_DETAILS_BY_CONTACT_TYPE, WHO_AM_I_OPTIONS } from 'views/ContactPage/constants';

const ContactForm = ({ data, errors, isSubmitting, handleChange, handleSubmit }) => {
  const isMobile = useSelector(selectIsMobile);

  const formDetails = FORM_DETAILS_BY_CONTACT_TYPE[data.whoAmI] || {};

  return (
    <Box component="form" mt={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1" align="right">
            * Required field
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            margin="none"
            type="text"
            label="Name *"
            id="name"
            name="name"
            inputProps={{ maxLength: 75 }}
            value={data.name}
            onChange={handleChange}
            error={errors.name}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            margin="none"
            type="text"
            label="Phone Number"
            id="phone"
            name="phone"
            value={data.phone}
            onChange={handleChange}
            error={errors.phone}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            margin="none"
            type="email"
            label="Email Address *"
            id="email"
            name="email"
            value={data.email}
            onChange={handleChange}
            error={errors.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            margin="none"
            label="I am a... *"
            options={WHO_AM_I_OPTIONS.map((value) => ({ value, label: value }))}
            id="whoAmI"
            name="whoAmI"
            value={data.whoAmI}
            onChange={handleChange}
            error={errors.whoAmI}
            native
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            margin="none"
            label="Subject *"
            native
            options={(formDetails?.subjects || []).map((options) => ({
              value: options.id,
              label: options.name,
            }))}
            id="subject"
            name="subject"
            value={data.subject}
            onChange={handleChange}
            error={errors.subject}
            disabled={!data.whoAmI}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            margin="none"
            id="message"
            name="message"
            label="Message *"
            multiline
            rows={6}
            value={data.message}
            onChange={handleChange}
            error={errors.message}
          />
        </Grid>
        {formDetails.enableGigIdField && (
          <Grid item xs={12} md={6}>
            <TextField
              margin="none"
              type="text"
              label="Gig ID #"
              id="gigId"
              name="gigId"
              value={data.gigId}
              onChange={handleChange}
              error={errors.gigId}
            />
          </Grid>
        )}
        {formDetails.enableMemberIdField && (
          <Grid item xs={12} md={6}>
            <TextField
              margin="none"
              type="text"
              label="Member ID #"
              id="memberId"
              name="memberId"
              value={data.memberId}
              onChange={handleChange}
              error={errors.memberId}
            />
          </Grid>
        )}
        <Grid item xs={12} textAlign="right">
          <Button
            size="medium"
            fullWidth={isMobile}
            disabled={isSubmitting}
            loading={isSubmitting}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

ContactForm.propTypes = {
  data: PropTypes.shape({}),
  errors: PropTypes.shape({}),
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};

ContactForm.defaultProps = {
  data: {},
  errors: {},
  isSubmitting: false,
};

export default ContactForm;
